import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import PrivateRoute from './routes/PrivateRoute';
import history from './routes/history';

import * as pages from './pages';
import { ROUTES } from './routes';

import '@spark-labs/avocado-ui/dist/index.css';
import { FeedEditorCtxProvider } from './context/FeedEdtitorContext';
import { WithPublicServerInfo } from './context/PublicServerInfoContext';
import './lib/icons';
import ModuleProvider from '@go-client/go-modules/core/ModuleContext';
import ModuleRoutes from '@go-client/go-modules/core/ModuleRoutes';

const WithGlobalProviders: React.FC = ({ children }) => {
  return (
    <FeedEditorCtxProvider>
      {children}
      <div id="AlertsArea" />
      <div id="toast-container" />
    </FeedEditorCtxProvider>
  );
};

export default function App() {
  return (
    <WithGlobalProviders>
      <WithPublicServerInfo>
        <ModuleProvider>
          <Router history={history}>
            <div id="App" className="w-full h-full absolute">
              <Switch>
                <Route path={ROUTES.LOGIN_ROUTE()} component={pages.Login} />

                <PrivateRoute exact path={ROUTES.HOME_ROUTE()} component={pages.Home} />

                <PrivateRoute exact path={ROUTES.HELP_ROUTE()} component={pages.Help} />

                <PrivateRoute exact path={ROUTES.PROPERTIES_ROUTE()} component={pages.Properties} />

                <PrivateRoute
                  exact
                  path={ROUTES.BRAND_SETTINGS_ROUTE()}
                  component={pages.BrandConfigs}
                />

                <PrivateRoute
                  exact
                  path={ROUTES.SUPER_ADMIN_SETTINGS_ROUTE()}
                  component={pages.SuperAdminConfig}
                />

                <PrivateRoute path={ROUTES.ITINERARIES_ROUTE()} component={pages.Itinerary} />
                <PrivateRoute path={ROUTES.TEMPLATES_ROUTE()} component={pages.Templates} />
                <PrivateRoute path={ROUTES.NOTIFICATIONS_ROUTE()} component={pages.Notifications} />
                <PrivateRoute
                  path={ROUTES.PROPERTY_SETTINGS_ROUTE()}
                  component={pages.PropConfigs}
                />

                <PrivateRoute exact path={ROUTES.GROUPS_ROUTE()} component={pages.GroupsHome} />
                <PrivateRoute
                  exact
                  path={ROUTES.GROUP_PARTIES_ROUTE()}
                  component={pages.GroupParties}
                />

                <PrivateRoute path={ROUTES.PLANNER_ROUTE()} component={pages.SailingDailyPlanner} />
                <PrivateRoute
                  path={ROUTES.TEMPLATE_PLANNER_ROUTE()}
                  component={pages.TemplateDailyPlanner}
                />

                <PrivateRoute
                  path="/reports/:sailingId/:sailingDay"
                  component={pages.ReportsDashboard}
                />

                <PrivateRoute path={ROUTES.FEED_ROUTE()} component={pages.SailingFeedEditor} />
                <PrivateRoute
                  path={ROUTES.TEMPLATE_FEED_ROUTE()}
                  component={pages.TemplateFeedEditor}
                />

                <PrivateRoute
                  path={ROUTES.LIBRARIES_ROUTE('events')}
                  component={pages.EventLibrary}
                />
                <PrivateRoute
                  path={ROUTES.LIBRARIES_ROUTE('venues')}
                  component={pages.VenueLibrary}
                />
                <PrivateRoute
                  path={ROUTES.LIBRARIES_ROUTE('staff')}
                  component={pages.StaffLibrary}
                />
                <PrivateRoute
                  path={ROUTES.LIBRARIES_ROUTE('content')}
                  component={pages.ContentLibrary}
                />

                <PrivateRoute path={ROUTES.ASSETS_ROUTE('images')} component={pages.ImageLibrary} />

                {/* DEPRECATED */}
                <PrivateRoute
                  path={ROUTES.LIBRARIES_ROUTE('plans')}
                  component={pages.PlanLibrary}
                />
                <PrivateRoute path={ROUTES.LIBRARIES_ROUTE('feed')} component={pages.FeedLibrary} />
                {/* DEPRECATED */}

                <Route path={ROUTES.MAINTENANCE_ROUTE()} component={pages.MaintenanceMode} />
                <Route path={ROUTES.CHECK_VERSION_ROUTE()} component={pages.CheckGOVersion} />

                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('events')}
                  component={pages.EventLibraryTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('venues')}
                  component={pages.VenueLibraryTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('content')}
                  component={pages.ContentLibraryTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('miscellaneous')}
                  component={pages.UITranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('segments')}
                  component={pages.SegmentTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('levels')}
                  component={pages.LevelTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('attributes')}
                  component={pages.AttributeTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('venueTypes')}
                  component={pages.VenueTypeTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('mealPeriods')}
                  component={pages.MealPeriodTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('dayThemes')}
                  component={pages.DayThemeTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('highlights')}
                  component={pages.HighlightTranslations}
                />
                <PrivateRoute
                  path={ROUTES.TRANSLATIONS_ROUTE('commonTexts')}
                  component={pages.CommonTextTranslations}
                />

                <PrivateRoute path="/tools/user-actions" component={pages.UserActions} />
                <PrivateRoute path="/tools/kafka-control" component={pages.KafkaControl} />
                <PrivateRoute path="/tools/user-management" component={pages.UserManagement} />
                <PrivateRoute
                  path={ROUTES.ITINERARY_MANAGEMENT_ROUTE()}
                  component={pages.ItineraryManagement}
                />

                <PrivateRoute
                  path={ROUTES.FEED_BLUEPRINT_ROUTE()}
                  component={pages.FeedBlueprintEditor}
                />

                {/* GO Modules routes */}
                <ModuleRoutes />

                <Route render={() => <pages.NotFound404 />} />
              </Switch>
            </div>
          </Router>
        </ModuleProvider>
      </WithPublicServerInfo>
    </WithGlobalProviders>
  );
}
